import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/AllWellNewLogo.png";

export default function PrivacyNotice({
  policyHref = "/privacy-policy",
  detailsHref = "/privacy-details",
  className = "",
}) {
  const [visible, setVisible] = useState(false);
  const [optOut, setOptOut] = useState(false);

  useEffect(() => {
    try {
      const dismissed = localStorage.getItem("privacyNoticeDismissed");
      const stored = localStorage.getItem("privacyOptOut");
      if (!dismissed) setVisible(true);
      if (stored === "true") setOptOut(true);
    } catch (err) {
      console.warn("localStorage not accessible:", err);
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    try {
      localStorage.setItem("privacyNoticeDismissed", "true");
      localStorage.setItem("privacyOptOut", optOut ? "true" : "false");
      document.cookie = `aw_consent=${optOut ? "optout" : "ok"}; path=/; max-age=${60 * 60 * 24 * 365}`;
    } catch (err) {
      console.warn("Unable to persist privacy settings:", err);
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-labelledby="aw-privacy-title"
      aria-describedby="aw-privacy-desc"
      className={`fixed bottom-0 left-0 right-0 z-50 border-t border-gray-200 bg-gray-100/95 backdrop-blur ${className}`}
    >
      <div className="max-w-6xl mx-auto px-4 py-4">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          {/* Left: logo + copy */}
          <div className="flex items-start gap-4">
            <img
              src={Logo}
              alt="AllWell Companion Home Care"
              className="h-20 sm:h-20 md:h-28 w-auto opacity-100"
              style={{ background: "transparent" }}
            />
            <div>
              <h3 id="aw-privacy-title" className="font-semibold text-gray-900 text-lg">
                Privacy Information
              </h3>
              <p id="aw-privacy-desc" className="text-sm text-gray-700 mt-1 max-w-2xl">
                We use cookies and similar technologies to improve your experience and provide our services.
                We respect your privacy and <strong>do not sell your personal information</strong>. For details,
                see our{" "}
                <Link to={policyHref} className="text-blue-700 underline hover:no-underline">
                  Privacy Policy
                </Link>
                . More information:{" "}
                <Link to={detailsHref} className="text-blue-700 underline hover:no-underline">
                  Details
                </Link>
                .
              </p>
            </div>
          </div>

          {/* Right: actions */}
          <div className="flex flex-col items-stretch md:items-end gap-3 md:min-w-[320px]">
            <button
              onClick={handleAccept}
              className="h-10 rounded-md bg-purple-700 px-6 text-white font-semibold shadow hover:bg-purple-800 focus:outline-none focus:ring-2 focus:ring-purple-500"
            >
              OK
            </button>

            <label className="inline-flex items-center gap-2 text-sm text-gray-800 select-none">
              <span className="relative inline-flex items-center">
                <input
                  type="checkbox"
                  checked={optOut}
                  onChange={(e) => setOptOut(e.target.checked)}
                  className="peer sr-only"
                  aria-label="Do not sell my personal information"
                />
                <span className="h-6 w-11 rounded-full bg-gray-300 peer-checked:bg-gray-900 transition-colors" />
                <span className="absolute left-0.5 top-0.5 h-5 w-5 rounded-full bg-white shadow transition-all peer-checked:translate-x-5" />
              </span>
              Do not sell my personal information
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}
